import React, { createContext, useContext, useState } from "react";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [mode, setMode] = useState("executive"); // executive | engineering
  return (
    <AppCtx.Provider value={{ mode, setMode }}>{children}</AppCtx.Provider>
  );
}

export const useApp = () => useContext(AppCtx);
